import { NotifyHelper } from "../../../../helpers/toast";
import { eNhomDeThiInActionsObj } from "../../../action-types/de-thi/de-thi-in/INhomDeThiInActions";
import { generateActionForKey, generateActions } from "../../generateActions";

export const nhomDeThiActions = {
  ...generateActions(eNhomDeThiInActionsObj, "NHOM_DE_THI_IN"),
  ...generateActionForKey(
    eNhomDeThiInActionsObj,
    "NHOM_DE_THI_IN",
    "SAVE_SUCCESS",
    () => {
      NotifyHelper.Success("Đã cập nhật");
    }
  ),
  ...generateActionForKey(
    eNhomDeThiInActionsObj,
    "NHOM_DE_THI_IN",
    "SAVE_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eNhomDeThiInActionsObj,
    "NHOM_DE_THI_IN",
    "DELETE_SUCCESS",
    () => {
      NotifyHelper.Success("Đã xóa");
    }
  ),
  ...generateActionForKey(
    eNhomDeThiInActionsObj,
    "NHOM_DE_THI_IN",
    "DELETE_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eNhomDeThiInActionsObj,
    "NHOM_DE_THI_IN",
    "DELETE_MULTIPLE_SUCCESS",
    () => {
      NotifyHelper.Success("Đã xóa");
    }
  ),
  ...generateActionForKey(
    eNhomDeThiInActionsObj,
    "NHOM_DE_THI_IN",
    "DELETE_MULTIPLE_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
};
